"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PredictionAnswer = void 0;
var PredictionAnswer;
(function (PredictionAnswer) {
    PredictionAnswer["LEFT"] = "LEFT";
    PredictionAnswer["RIGHT"] = "RIGHT";
})(PredictionAnswer || (exports.PredictionAnswer = PredictionAnswer = {}));
//# sourceMappingURL=answer.js.map